import type { TranslationKey } from "@privacy/translations";
import { useTranslation } from "@privacy/translations";
import type { FC } from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import { PlusIcon } from "../shared/icons";
import { HACK_alignIconWithLabelBox } from "@privacy/ui";

type GridCreateNewButtonProps = {
  labelKey: TranslationKey;
  renderDialog: (props: { onClose: () => void }) => React.ReactNode;
  onHover?: () => void;
};
export const CreateNewButton: FC<GridCreateNewButtonProps> = ({ renderDialog, labelKey, onHover }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        sx={{ textWrap: "nowrap" }}
        startIcon={<PlusIcon size={14} />}
        onClick={() => setIsOpen(true)}
        onMouseEnter={onHover}
        onFocus={onHover}
      >
        <HACK_alignIconWithLabelBox>{t(labelKey)}</HACK_alignIconWithLabelBox>
      </Button>

      {isOpen && renderDialog({ onClose: () => setIsOpen(false) })}
    </>
  );
};
